import request from '@/axios/axios'

// 日志列表
export function getList(query) {
  return request({
    url: '/device/v1/logs/upload/page',
    method: 'get',
    params: query
  })
}

// 启动收集
export function startCollect(params) {
  return request({
    url: '/device/v1/logs/upload/start-collecting-log',
    method: 'post',
    data: params
  })
}

// 停止收集
export function stopCollect(params) {
  return request({
    url: 'device/v1/logs/upload/stop-collecting-log',
    method: 'post',
    data: params
  })
}

// 设备列表
export function deviceList(params) {
  return request({
    url: '/device/v1/get-all-device-list',
    method: 'post',
    data: params
  })
}

// 设备日志分页查询(TDengine)
export function deviceLogPageList(params) {
  return request({
    url: '/log/v2/device/log',
    method: 'post',
    data: params
  })
}

// 日志类型
export function getLogTypeList() {
  return request({
    url: '/log/v1/device/get-log-type-list',
    method: 'post'
  })
}


// 配置查询 - 子设备列表
export function getSubDeviceList(params) {
  return request({
    url: '/device/v1/config/publish/log/get-sub-device-list',
    method: 'post',
    data: params
  })
}

// 配置查询 - 子设备列表- 导出子设备列表
export function exportSubDeviceList(query) {
  return request({
    url: `/device/v1/config/publish/log/export-sub-device-list`,
    method: 'post',
    data: query,
    responseType: 'blob' // 强制axios将响应视为一个BLOB
  })
}

// 配置查询 - 场景列表
export function getSceneList(params) {
  return request({
    url: `/device/v1/config/publish/log/get-scene-list`,
    method: 'post',
    data: params
  })
}

// 配置查询 - 场景列表 - 导出场景列表
export function exportSceneList(query) {
  return request({
    url: `/device/v1/config/publish/log/export-scene-list`,
    method: 'post',
    data: query,
    responseType: 'blob' // 强制axios将响应视为一个BLOB
  })
}

// 配置下发
export function postPublish(params) {
  return request({
    url: `/device/v1/config/publish/log/publish`,
    method: 'post',
    data: params
  })
}

// 配置下发日志分页查询
export function postPublishLogPage(params) {
  return request({
    url: `/device/v1/config/publish/log/page`,
    method: 'post',
    data: params
  })
}

// 配置下发日志详情查询
export function postPublishLogDetail(params) {
  return request({
    url: `/device/v1/config/publish/log/detail`,
    method: 'post',
    data: params
  })
}
